import { useEffect, useState } from "react"
import { AppInfo } from "../../../../service/app-manager/AppManager"
import AppJson from "../../../../data/app.json";
import { ASSET_SERVER, ROUTER_NAME } from "config/env";


export const useApps = () => {
    const [apps, setApps] = useState<AppInfo[]>([])

    useEffect(() => {
        getAppJson().then((data) => {
            data = data.map((app: any) => {
                return {
                    ...app,
                    cover: `${ROUTER_NAME}/applications/apps/${app.id}/${app.cover}`,
                    dynamicCover: `${ROUTER_NAME}/applications/apps/${app.id}/${app.dynamicCover}`,
                };
            });
            setApps(data);
        })
    }, [])

    return {
        apps,
    }
}

export const useOpenApp = () => {
    
    const openApp = async (appInfo: AppInfo) => {
        console.log(appInfo.id,'appInfo')
        
        // 打开新窗口并带上appInfo.id参数
        const url = `/${appInfo.id}/`
        window.open(url, '_blank')
    }

    return {
        openApp,
    }
}


async function getAppJson() {
    try {
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), 5000);
        const response = await fetch(`${ROUTER_NAME}/applications/apps/app.json`, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-cache', // 防止缓存
                'Pragma': 'no-cache'         // 兼容旧版HTTP
            },
            signal: controller.signal
        }).finally(() => clearTimeout(id));
        const ret = await response.json()
        return ret;
    } catch {
        return []
    }
}